export default "__VITE_ASSET__DSs8gk6x__"